import type { SortDir } from "@gw/shared-types";
import { InfoTooltip } from "@/components/InfoTooltip";

export interface SortState {
  key: string;
  dir: SortDir;
}

interface Props {
  label: string;
  sortKey: string;
  sort: SortState;
  setSort: (s: SortState) => void;
  numeric?: boolean;
  /** Optional column-concept tooltip rendered after the label. The InfoTooltip stops click +
   *  Space/Enter propagation, so interacting with it won't trigger the column's sort. */
  info?: string;
  /** Extra classes for the <th> (e.g. col-pin* for frozen/sticky columns). */
  className?: string;
}

export function SortHead({ label, sortKey, sort, setSort, numeric, info, className }: Props) {
  const isSorted = sort.key === sortKey;
  const ariaSort: "ascending" | "descending" | "none" = isSorted
    ? sort.dir === "asc"
      ? "ascending"
      : "descending"
    : "none";
  return (
    <th
      aria-sort={ariaSort}
      className={[isSorted ? "sorted" : "", numeric ? "numeric" : "", className ?? ""]
        .filter(Boolean)
        .join(" ")}
      onClick={() =>
        setSort({
          key: sortKey,
          dir: isSorted && sort.dir === "desc" ? "asc" : "desc",
        })
      }
    >
      {label}
      <span className="sort-arrow">{isSorted ? (sort.dir === "desc" ? "▼" : "▲") : "↕"}</span>
      {info && <InfoTooltip text={info} inline />}
    </th>
  );
}
